var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFusion360(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "480px",
    height: "480px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#26a69a",
    d: "M13.539,33l-1.976-1.854L4,31.166c0,0.472,0.005,0.69,0.346,1.344l4.939,9.134 C9.825,42.592,10.389,43,11.473,43c1.682,0,3.904-1.367,4.527-1.75C19.269,39.241,29.034,33,29.034,33H13.539z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009688",
    d: "M14.91,41.64c0.04,0.06,0.07,0.12,0.11,0.18C14.05,42.35,12.63,43,11.47,43 c-1.08,0-1.64-0.41-2.19-1.36l-4.93-9.13C4.01,31.86,4,31.636,4,31.166l5.593-0.015c0.01,0.32,0.107,0.839,0.377,1.359L14.91,41.64z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4db6ac",
    d: "M29.03,33c0,0-2.62,1.68-5.61,3.57c-1.4,0.89-2.87,1.83-4.19,2.66L15.86,33H29.03z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#80cbc4",
    d: "M29.03,33c0,0-2.62,1.68-5.61,3.57L21.49,33H29.03z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#33691e",
    d: "M23.66,7.59l-1.35,4.25l-0.95,2.99L13.62,33H6.91C4.88,33,4,32.22,4,31.17 c0-0.42,0.22-1.04,0.51-1.78l8.78-20.9l1.01-2.4c0,0,0.32-1.09,1.7-1.09c1.25,0,0.86,0.07,0.86,0.07L23.66,7.59z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#558b2f",
    d: "M22.31,11.84l-0.95,2.99l-0.51,1.2L13.62,33H6.91C4.88,33,4,32.22,4,31.17 c0-0.42,0.22-1.04,0.51-1.78l7.06-16.8l1.72-4.1L22.31,11.84z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#689f38",
    d: "M20.85,16.03l-1.75,4.1L13.62,33H6.91C4.88,33,4,32.22,4,31.17c0-0.42,0.22-1.04,0.51-1.78l5.34-12.7 l1.72-4.1L20.85,16.03z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#7cb342",
    d: "M19.1,20.13l-1.74,4.09L13.62,33H6.91C4.88,33,4,32.22,4,31.17c0-0.42,0.22-1.04,0.51-1.78l3.61-8.59 l1.73-4.11L19.1,20.13z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8bc34a",
    d: "M17.36,24.22l-1.75,4.1L13.62,33H6.91C4.88,33,4,32.22,4,31.17c0-0.42,0.22-1.04,0.51-1.78L6.4,24.9 l1.72-4.1L17.36,24.22z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#9ccc65",
    d: "M15.61,28.32l-1.76,4.13L13.62,33H6.91C4.88,33,4,32.22,4,31.17c0-0.42,0.22-1.04,0.51-1.78 l0.16-0.37L6.4,24.9L15.61,28.32z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#aed581",
    d: "M13.85,32.45L13.62,33H6.91C4.88,33,4,32.22,4,31.17c0-0.42,0.22-1.04,0.51-1.78l0.16-0.37 L13.85,32.45z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#29b6f6",
    d: "M44,43H33.26l-1.69-4l-1.7-4l-0.56-1.33l-0.57-1.34L28.18,31l-0.85-2l-0.84-2h-0.01l-1.69-4l-0.42-1 l-1.27-3l-1.69-4H21.4l-3.38-8l-0.2-0.48C17.55,5.9,17.1,5,16,5h10.71c0.99,0,1.46,0.58,1.67,1.11L28.76,7l1.69,4l0.05,0.1l1.64,3.9 l0.03,0.06L33.83,19l0.03,0.06L35.53,23l0.01,0.02L37.22,27l0.02,0.04L38.92,31l1.69,4h0.01l1.29,3.06l0.4,0.94L44,43z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M44 43L33.26 43 31.57 39 29.87 35 29.31 33.67 28.74 32.33 28.18 31 27.33 29 26.49 27 26.48 27 24.79 23 24.37 22 23.1 19 21.41 15 21.4 15 18.02 7 28.76 7 30.45 11 30.5 11.1 32.14 15 32.17 15.06 33.83 19 33.86 19.06 35.53 23 35.54 23.02 37.22 27 37.24 27.04 38.92 31 40.61 35 40.62 35 41.91 38.06 42.31 39z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#039be5",
    d: "M44 43L33.26 43 31.57 39 29.87 35 29.31 33.67 28.74 32.33 28.18 31 27.33 29 26.48 27 24.79 23 24.37 22 23.1 19 23.09 19 19.71 11 30.45 11 32.14 15 32.17 15.06 33.83 19 33.86 19.06 35.53 23 35.54 23.02 37.22 27 37.24 27.04 38.92 31 40.61 35 40.62 35 41.91 38.06 42.31 39z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0288d1",
    d: "M44 43L33.26 43 31.57 39 29.87 35 29.31 33.67 28.74 32.33 28.18 31 27.33 29 26.48 27 24.79 23 24.37 22 23.09 19 21.4 15 32.14 15 32.17 15.06 33.83 19 33.86 19.06 35.53 23 35.54 23.02 37.22 27 37.24 27.04 38.92 31 40.61 35 40.62 35 41.91 38.06 42.31 39z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c74c6",
    d: "M44 43L33.26 43 31.57 39 29.87 35 29.31 33.67 28.74 32.33 28.18 31 27.33 29 26.49 27 26.48 27 24.79 23 24.37 22 23.09 19 33.83 19 33.86 19.06 35.53 23 35.54 23.02 37.22 27 37.24 27.04 38.92 31 40.61 35 40.62 35 41.91 38.06 42.31 39z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3163af",
    d: "M44 43L33.26 43 31.57 39 29.87 35 29.31 33.67 28.74 32.33 28.18 31 27.33 29 26.48 27 24.79 23 35.53 23 35.54 23.02 37.22 27 37.24 27.04 38.92 31 40.61 35 40.62 35 41.91 38.06 42.31 39z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a5dac",
    d: "M44 43L33.26 43 31.57 39 29.87 35 29.31 33.67 28.74 32.33 28.18 31 27.33 29 26.48 27 37.22 27 37.24 27.04 38.92 31 40.61 35 40.62 35 41.91 38.06 42.31 39z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2056a9",
    d: "M44 43L33.26 43 31.57 39 29.87 35 29.31 33.67 28.74 32.33 28.18 31 38.92 31 40.61 35 40.62 35 41.91 38.06 42.31 39z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#1950a6",
    d: "M44 43L33.26 43 31.57 39 29.87 35 40.62 35 41.91 38.06 42.31 39z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d47a1",
    d: "M42.31 39L44 43 33.26 43 31.57 39z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusion360);
export default __webpack_public_path__ + "static/media/fusion360.7fd98aeba68fdda51367217f3ac052cd.svg";
export { ForwardRef as ReactComponent };